var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"xw-file-update",on:{"click":_vm.click}},[_vm._v(" 上传 "),_c('input',{ref:"upload",attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }